import { Component, OnInit, Input, OnDestroy, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { CorrectionModel, DataCorrectionArrayEvent, DataCorrectionArrayEventOperation, DataCorrectionInstance, DataCorrectionInstanceStatus, DataCorrectionStepDate } from '../../../../models/dataCorrection/dataCorrection.model';
import { DataCorrectionService } from '../../../../services/dataCorrection.service';
import { Subscription, Observable, of } from 'rxjs';
import { map, mergeMap, catchError } from "rxjs/operators";
import { LoaderService } from '../../../../common/services/loader.service';
import { FormBuilder, FormArray, FormGroup, FormControl, AbstractControl } from '@angular/forms';
import { IUploadFile, DocumentManagementService } from '../../../../common/services/document-management.service';
import { DomainValue } from '../../../../common/models/document-tag.model';
import { deepClone } from '../../../../builder/models/editor.model';
import { AuthService } from '../../../../services/auth.service';
import { LunaEntity } from '../../../../builder/models/entity.model';
import { OrganizationService } from '../../../../common/services/organization.service';
import { Router } from '@angular/router';
import { DynamicDialogService } from '../../../../core/services/dynamic-dialog.service';
import { Dialog, DialogButton } from '../../../../core/models/dialog.model';
import { WorkOrderService } from '../../../../common/services/work-order.service';
import { WorkOrderStatus } from '../../../../common/models/work-order.model';
import { UploadViewFilesComponent } from '../../../../common/components/fileUpload/upload-view-files.component';
import { SubHeader } from '../../../../core/models/sub-header.model';
import { SubHeaderService } from '../../../../core/services/sub-header.service';
import { getPropertyValue, setPropertyValue } from "../../../../common/models/data-manipulation-functions";

@Component({
    selector: 'data-correction',
    templateUrl: './data-correction.component.html',
    styleUrls: ['./data-correction.component.scss'],
    standalone: false
})
export class DataCorrectionComponent implements OnInit, OnDestroy  {

	@ViewChild(UploadViewFilesComponent) public _uploadViewFilesElement: UploadViewFilesComponent;

    dataChangeForm: FormGroup;
    correctionData: CorrectionModel[] = [];
    correctionDataInstance: DataCorrectionInstance = {};
    showInitialValues: { [id: string]: boolean; } = {};
    currentlyAddingAdHocReview: boolean = false;
    showOnlyAlteredFields: boolean = true;
    viewAllButtonText: string = "View All";

    _defaultDocumentType: DomainValue = { value: "", displayName: "--Select Document Type--" } as DomainValue;
    documentTypes: DomainValue[] = [this._defaultDocumentType];

    submitComplete: boolean = false;

    applicationSubmittedDialog: Dialog = new Dialog("Your application has been submitted for review.", [new DialogButton("OK", true, () => this.onDialogClick())]);
    applicationReturnedDialog: Dialog = new Dialog("Your application has been returned for corrections.", [new DialogButton("OK", true, () => this.onDialogClick())]);
    applicationDeniedDialog: Dialog = new Dialog("The application has been denied.", [new DialogButton("OK", true, () => this.onDialogClick())]);
    applicationApprovedDialog: Dialog = new Dialog("The application has been approved.", [new DialogButton("OK", true, () => this.onDialogClick())]);
    adHocReviewApprovedDialog: Dialog = new Dialog("Your Ad Hoc review has been approved.", [new DialogButton("OK", true, () => this.onDialogClick())]);
    adHocReviewReturnedDialog: Dialog = new Dialog("Your Ad Hoc review has been returned.", [new DialogButton("OK", true, () => this.onDialogClick())]);
    reviewSavedDialog: Dialog = new Dialog("Your Review Notes have been saved.", [new DialogButton("OK", true, () => {}), new DialogButton("Return to Dashboard", true, () => this.onDialogClick())]);

    subscriptions: Subscription = new Subscription();
    @Input() isInReviewMode: boolean;
    @Input() adHocReviewWorkOrderId: string;
    @Input() dataModel: EventEmitter<CorrectionModel[]>;
    @Input() correctionDataInstanceEmitter: EventEmitter<DataCorrectionInstance>;
    @Input() objectEntity: LunaEntity = null;

    subHeader: SubHeader = new SubHeader({ title: "Administrative Data Correction" });

    constructor(private dataCorrectionSrv: DataCorrectionService, private readonly loader: LoaderService, private organizationService: OrganizationService,
        private authService: AuthService, private documentService: DocumentManagementService, private _router: Router, private _dialogService: DynamicDialogService,
        private workOrderService: WorkOrderService, private formBuilder: FormBuilder, private subHeaderService: SubHeaderService, private detector: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.subHeaderService.updateSubHeader(this.subHeader);
        if (this.dataModel) {
            let dataModel$ = this.dataModel.subscribe(result => {
                this.correctionData = result;
                if (this.correctionData.length > 0) {
                    this.createForm();

                    //If no instance was provided, initialize it
                    if (!this.correctionDataInstance.id) {
                        this.correctionDataInstance.uploadedFiles = [];

                        this.correctionDataInstance.updatedFields = deepClone(this.correctionData);
                    }
                }
            },
                (error) => { console.error(error); });
            this.subscriptions.add(dataModel$);

			let correctionDataInstance = this.correctionDataInstanceEmitter.subscribe(result => {
				console.log('received instance', result);
                this.correctionDataInstance = result;
            },
                (error) => { console.error(error); });
            this.subscriptions.add(correctionDataInstance);

            let docTypeObs$ = this.documentService.documentTypes.subscribe(result => {
                if (result && result.length > 0) {
                    this.documentTypes = result;
                    this.documentTypes.unshift(this._defaultDocumentType);
                }
            },
                (error) => { console.error(error); });
            this.subscriptions.add(docTypeObs$);

        }
    }

    ngOnDestroy() {
        if (this.subscriptions) this.subscriptions.unsubscribe();
    }

    createFormGroup(correctionModel: CorrectionModel[]): FormGroup {
        let objectFormGroup: FormGroup;
        objectFormGroup = this.formBuilder.group({});

        objectFormGroup.get

        for (let x = 0; x < correctionModel.length; x++) {
            let correctionModelInstance = correctionModel[x];

            //If there are child correction properties, this is just a container
            if (correctionModelInstance.childCorrectionModels) {
                let childFormGroup = this.createFormGroup(correctionModelInstance.childCorrectionModels);
                objectFormGroup.addControl(correctionModelInstance.propertyDataSource, childFormGroup);
            }
            else {
                //Check for a corresponding entry in the correction model
                if (objectFormGroup.contains('' + correctionModelInstance.propertyDataSource + '')) {
                    //then set value
                    objectFormGroup.controls['' + correctionModelInstance.propertyDataSource + ''].setValue(correctionModelInstance.propertyValue);
                }
                else {
                    //else add control
                    objectFormGroup.addControl('' + correctionModelInstance.propertyDataSource + '', this.formBuilder.control(correctionModelInstance.propertyValue));
                }
            }

            
        }

        return objectFormGroup;
    }

    //findACorrectionModelEntryWithADataSource(correctionModels: CorrectionModel[], dataSource: string): CorrectionModel {
    //    for (let x = 0; x < correctionModels.length; x++) {
    //        if (correctionModels[x].propertyDataSource == dataSource)
    //            return correctionModels[x];
    //        else
    //            if (correctionModels[x].childCorrectionModels && correctionModels[x].childCorrectionModels.length > 0)
    //                return this.findACorrectionModelEntryWithADataSource(correctionModels[x].childCorrectionModels, dataSource);
    //            else return null;
    //    }
    //}
    
    createForm(): void {
        this.dataChangeForm = this.formBuilder.group({}); 
        if (this.correctionData.length > 0 && this.correctionData != null && this.correctionData != undefined) {
            let entityPropertyFormGroup = this.createFormGroup(this.correctionData);

            this.dataChangeForm.addControl("entity", entityPropertyFormGroup);

            //Add in file upload control and doc types
            this.dataChangeForm.addControl("uploadedFile", new FormControl([]));
            this.dataChangeForm.addControl("docType", new FormControl(""));

            //Add in notes control
            this.dataChangeForm.addControl("notes", new FormControl(""));
            this.dataChangeForm.addControl("reviewNotes", new FormControl(""));
        }

        this.validateForm();
    }

    validateForm(): boolean {
        this.dataChangeForm.updateValueAndValidity();
        return this.dataChangeForm.valid;;
    }

    setDataCorrectionInstanceFields(updatedFields = this.correctionDataInstance.updatedFields, formGroup: FormGroup = (this.dataChangeForm.controls['entity'] as FormGroup),
                                    setDataInstanceFields = true): Observable<string> {
        let organizationNameFetchObs: Observable<string>;

        if (setDataInstanceFields) {
            this.correctionDataInstance.entityId = this.objectEntity.id;
            this.correctionDataInstance.entityName = this.objectEntity.entityName;
        }

        //iterate through the correction model, and pull the relevant formcontrols, and their updated values
		updatedFields.forEach(correctionDataEntry => {
            let relevantFormControl = formGroup.controls[correctionDataEntry.propertyId];

            //If it's an array or object, any actual data is saved in the child correction data fields
            if (correctionDataEntry.propertyType !== "array" && correctionDataEntry.propertyType !== "object") {
				if (relevantFormControl && (relevantFormControl.value != correctionDataEntry.propertyValue || correctionDataEntry.propertyDataSource.endsWith('itemIsAdded'))) {

                    correctionDataEntry.propertyValue = relevantFormControl.value;

					let valueToSetOnObject = relevantFormControl.value;
					
                    //Need to make allowances for converting back date fields
                    if (valueToSetOnObject != null && valueToSetOnObject.length > 0 && correctionDataEntry.propertyType === "string" && (correctionDataEntry.propertyFormat === "date-time" || correctionDataEntry.propertyFormat === "date")) {
                        //By default, saves as midnight on day selected, and assumes it's UTC as opposed to local time. Need to convert to local time so it gets pulled back correctly
                        let dateTimeOffset = new Date().getTimezoneOffset() * 60000;                        
                        let utcMidnightDate = new Date(relevantFormControl.value).getTime();
                        valueToSetOnObject = new Date(utcMidnightDate + dateTimeOffset);
                    }

                    //Update the field on the object as well 
					setPropertyValue(this.correctionDataInstance.updatedObject, correctionDataEntry.propertyDataSource, valueToSetOnObject);              
                }
            }
			else {
				if (correctionDataEntry.childCorrectionModels == null || correctionDataEntry.childCorrectionModels.length === 0) {
					setPropertyValue(this.correctionDataInstance.updatedObject, correctionDataEntry.propertyDataSource, []);
				} else {
					let childFormGroup = formGroup.controls[correctionDataEntry.propertyId];
                    this.setDataCorrectionInstanceFields(correctionDataEntry.childCorrectionModels, childFormGroup as FormGroup, false);

                }
            }

            if (correctionDataEntry.propertyIsOrganizationId)
                this.correctionDataInstance.objectOrganizationId = relevantFormControl.value;
        });

        if (setDataInstanceFields) {
            this.correctionDataInstance.lastModifiedDate = this.setDataCorrectionStepDateInfo();

            //If there's no Id, this will be a new one, set the created date info
            if (!this.correctionDataInstance.id) {
                this.correctionDataInstance.createdDate = this.setDataCorrectionStepDateInfo();
            }

            //If no organization name has been provided, attempt to fetch it
            if (!this.correctionDataInstance.objectOrganizationName && this.correctionDataInstance.objectOrganizationId) {
                organizationNameFetchObs = this.organizationService.getOrganizationStub(this.correctionDataInstance.objectOrganizationId).pipe(
                    map((orgStub) => orgStub.name),
                    catchError((error) => {
                        console.error(error);
                        return of("Unknown");
                    }));
            }
            else {
                organizationNameFetchObs = of(this.correctionDataInstance.objectOrganizationName);
            }
        }

        return organizationNameFetchObs;
    }

    save(): boolean {
        this.loader.toggleLoader(true, "Saving Data Correction Request.");
        let validForSave = this.validateForm();

        if (validForSave) {

            let organizationSetFieldsObs = this.setDataCorrectionInstanceFields();

			let savedInstance$ = organizationSetFieldsObs.pipe(mergeMap((orgName: string) => {
				if (!this.correctionDataInstance.objectOrganizationName)
					this.correctionDataInstance.objectOrganizationName = orgName;

				return this.dataCorrectionSrv.saveDataCorrectionInstance(this.correctionDataInstance);
			})).subscribe((id) => {
                if (id && !this.correctionDataInstance.id) {
                    this.correctionDataInstance.id = id
                    //To avoid them starting a separate new data correction instance if they refresh the url and are on the initial page, navigate them to the one specifying the item id
                    this._router.navigate(['/admin/data-corrections/', this.correctionDataInstance.id]);
                }

                this.loader.toggleLoader(false);
                return true;
            },
                (error) => {
                    console.log(error);
                    this.loader.toggleLoader(false);
                    return false;
                });

            this.subscriptions.add(savedInstance$);
        }
        else return false;
    }

    saveAndReturnToDashboard() {

        let validForSave = this.validateForm();

        if (validForSave) {
            this.loader.toggleLoader(true);
            //Save off the instance again in case any notes were added.
            this.setDataCorrectionInstanceFields();

            let savedInstance$ = this.dataCorrectionSrv.saveDataCorrectionInstance(this.correctionDataInstance).subscribe((saveResponse) => {
                //bring up popup to navigate them to dashboard
                this.activateDialog(this.reviewSavedDialog);
                this.loader.toggleLoader(false);
            },
                (error) => {
                    console.log(error);
                    this.loader.toggleLoader(false);
                });

            this.subscriptions.add(savedInstance$);
        }
    }

    submit() {
        this.loader.toggleLoader(true, "Submitting Data Correction Request.");
        let validForSave = this.validateForm();

        if (validForSave) {
            let organizationSetFieldsObs = this.setDataCorrectionInstanceFields();
            this.correctionDataInstance.submittedDate = this.setDataCorrectionStepDateInfo();
            this.correctionDataInstance.status = DataCorrectionInstanceStatus.PendingReview;

            let savedInstance$ = organizationSetFieldsObs.pipe(mergeMap((orgName: string) => {
                if (!this.correctionDataInstance.objectOrganizationName)
                    this.correctionDataInstance.objectOrganizationName = orgName;
                return this.dataCorrectionSrv.saveDataCorrectionInstance(this.correctionDataInstance);
            })).subscribe((id) => {
                if (id && !this.correctionDataInstance.id) {
                    this.correctionDataInstance.id = id
                }

                //bring up popup to navigate them to dashboard
                this.activateDialog(this.applicationSubmittedDialog);

                this.loader.toggleLoader(false);
            },
                (error) => {
                    console.log(error);
                    this.loader.toggleLoader(false);
                });

            this.subscriptions.add(savedInstance$);
        }
    }

    return() {
        this.loader.toggleLoader(true, "Returning Data Correction Request.");
        let validForSave = this.validateForm();

        if (validForSave) {
            this.setDataCorrectionInstanceFields();
            this.correctionDataInstance.returnedDate = this.setDataCorrectionStepDateInfo();
            this.correctionDataInstance.status = DataCorrectionInstanceStatus.ReturnedForCorrections;

            let savedInstance$ = this.dataCorrectionSrv.saveDataCorrectionInstance(this.correctionDataInstance).subscribe((id) => {
                //bring up popup to navigate them to dashboard
                this.activateDialog(this.applicationReturnedDialog);

                this.loader.toggleLoader(false);
            },
            (error) => {
                console.log(error);
                this.loader.toggleLoader(false);
            });

            this.subscriptions.add(savedInstance$);
        }
    }

    approve() {
        this.loader.toggleLoader(true, "Approving Data Correction Request.");
        let validForSave = this.validateForm();

        if (validForSave) {
            this.setDataCorrectionInstanceFields();
            this.correctionDataInstance.approvedDate = this.setDataCorrectionStepDateInfo();
            this.correctionDataInstance.status = DataCorrectionInstanceStatus.Approved;

            let savedInstance$ = this.dataCorrectionSrv.saveDataCorrectionInstance(this.correctionDataInstance).pipe(mergeMap((savedInstance) => {
                return this.workOrderService.completeApplicationWorkOrders(this.correctionDataInstance.id);
            })).subscribe((workOrders) => {
                //bring up popup to navigate them to dashboard
                this.activateDialog(this.applicationApprovedDialog);

                this.loader.toggleLoader(false);
            },
            (error) => {
                console.log(error);
                this.loader.toggleLoader(false);
            });

            this.subscriptions.add(savedInstance$);
        }
    }

    deny() {
        this.loader.toggleLoader(true, "Denying Data Correction Request.");
        let validForSave = this.validateForm();

        if (validForSave) {
            this.setDataCorrectionInstanceFields();
            this.correctionDataInstance.deniedDate = this.setDataCorrectionStepDateInfo();
            this.correctionDataInstance.status = DataCorrectionInstanceStatus.Denied;

            let savedInstance$ = this.dataCorrectionSrv.saveDataCorrectionInstance(this.correctionDataInstance).pipe(mergeMap((savedInstance) => {
                return this.workOrderService.completeApplicationWorkOrders(this.correctionDataInstance.id);
            })).subscribe((workOrders) => {
                //bring up popup to navigate them to dashboard
                this.activateDialog(this.applicationDeniedDialog);

                this.loader.toggleLoader(false);
            },
                (error) => {
                    console.log(error);
                    this.loader.toggleLoader(false);
                });

            this.subscriptions.add(savedInstance$);
        }
    }

    setDataCorrectionStepDateInfo(): DataCorrectionStepDate {
        let date = {} as DataCorrectionStepDate;        
        date.date = new Date();
        date.userId = this.authService.User.id;
        date.userName = this.authService.User.displayName;
        return date;
    }

    activateDialog(dialog: Dialog) {
        dialog.toggleDialog(true);
        this._dialogService.updateDialog(dialog);
    }

    onDialogClick() {
        this._router.navigate(["/dashboard/view/ricsDashboard"]);
    };

    get hasFileListing(): boolean {
        return this.correctionDataInstance.uploadedFiles && this.correctionDataInstance.uploadedFiles.length > 0;
    }

    deleteFile(file: IUploadFile): void {
        //Reviewer can't delete files
        if (!this.isInReviewMode) {
            let fileDel$ = this.documentService.abandon(file).pipe()
                .subscribe(
                    (deleted) => {
                        let index = this.correctionDataInstance.uploadedFiles.findIndex(f => f.fileName === file.fileName);
                        if (index !== -1) {
                            this.correctionDataInstance.uploadedFiles.splice(index, 1);
                        }

                        //Now make sure the file got removed from the upload-view-files component too
                        this._uploadViewFilesElement.removeFile(file);
                    },
                    (error) => { console.error(error); }
                );
            this.subscriptions.add(fileDel$);
        }
    }   

    savedFiles(file: IUploadFile): void {
        this.correctionDataInstance.uploadedFiles.push(file);
        this.validateUpload();
    }

    validateUpload(): void {
        let upload = this.dataChangeForm.get("uploadedFile");
        upload.setValue(this.correctionDataInstance.uploadedFiles);
        upload.markAsTouched();
        upload.markAsDirty();
        upload.updateValueAndValidity();
    }  

    fieldHasBeenEdited(fieldDataSource: string) {
        let originalValue = getPropertyValue(this.correctionDataInstance.originalObject, fieldDataSource, "");
        let updatedValue = getPropertyValue(this.correctionDataInstance.updatedObject, fieldDataSource, "");

        //return originalValue !== updatedValue;
    }

    getFieldOriginalValue(fieldDataSource: string) {
        let originalValue = getPropertyValue(this.correctionDataInstance.originalObject, fieldDataSource, "N/A");

        return originalValue !== undefined && originalValue !== null && originalValue !== "" ? originalValue.toString() : "N/A";
    }

    toggleShowInitialValue(dataSource: string, value: boolean): void {
        this.showInitialValues[dataSource] = value;
    }

    getAdHocWorkOrderDescription(): string {
        if (this.correctionDataInstance && this.isInReviewMode) {
            return `Ad hoc Review of Data Correction ${this.correctionDataInstance.id}`;
        }
        else
            return null;
    }

    getAdHocWorkOrderTargetUrlPrefix(): string {
        if (this.correctionDataInstance && this.isInReviewMode) {
            return `/admin/data-corrections/${this.correctionDataInstance.id}`;
        }
        else
            return null;
    }

    toggleAddAdHocReview(value: boolean = !this.currentlyAddingAdHocReview) {
        this.saveAndReturnToDashboard();
        this.currentlyAddingAdHocReview = value;
    }

    addAdHocReview() {
        this.currentlyAddingAdHocReview = true;
    }

    adHocApprove() {
        this.loader.toggleLoader(true, "Approving Ad hoc Review");
        let validForSave = this.validateForm();

        if (validForSave) {
            //Save off the instance again in case ad hoc review edited, added, to notes.
            this.setDataCorrectionInstanceFields();

            let savedInstance$ = this.dataCorrectionSrv.saveDataCorrectionInstance(this.correctionDataInstance).pipe(mergeMap((id) => {                
                return this.workOrderService.changeStatus(this.adHocReviewWorkOrderId, WorkOrderStatus.Completed);
                })).subscribe((workOrder) => {
                    //bring up popup to navigate them to dashboard
                    this.activateDialog(this.adHocReviewApprovedDialog);


                    this.loader.toggleLoader(false);
                    },
                    (error) => {
                        console.log(error);
                        this.loader.toggleLoader(false);
                    });

            this.subscriptions.add(savedInstance$);
        }
    }

    adHocReturn() {
        this.loader.toggleLoader(true, "Returning Ad hoc Review");
        let validForSave = this.validateForm();

        if (validForSave) {
            //Save off the instance again in case ad hoc review edited, added, to notes.
            this.setDataCorrectionInstanceFields();

            let savedInstance$ = this.dataCorrectionSrv.saveDataCorrectionInstance(this.correctionDataInstance).pipe(mergeMap((id) => {
                return this.workOrderService.changeStatus(this.adHocReviewWorkOrderId, WorkOrderStatus.Returned);
            })).subscribe((workOrder) => {
                //bring up popup to navigate them to dashboard
                this.activateDialog(this.adHocReviewReturnedDialog);

                this.loader.toggleLoader(false);
            },
                (error) => {
                    console.log(error);
                    this.loader.toggleLoader(false);
                });

            this.subscriptions.add(savedInstance$);
        }
    }

	onCorrectionDataArrayChanged(correctionDataArrayChangedEvent: DataCorrectionArrayEvent) {
        this.processDataCorrectionArrayChangeEvent(correctionDataArrayChangedEvent);
        //Now update the correction instance's updatedFields
		this.correctionDataInstance.updatedFields = deepClone(this.correctionData);
		this.detector.detectChanges();
    }

    processDataCorrectionArrayChangeEvent(correctionDataArrayChangedEvent: DataCorrectionArrayEvent, correctionModelArrayToCheck: CorrectionModel[] = this.correctionData,
		formGroupToUpdate: FormGroup = this.dataChangeForm.controls['entity'] as FormGroup, arrayPositions: number[] = []) {
		console.log('at start of processDataCorrectionArrayChangedEvent, arrayPositions is', arrayPositions);
        let numberOfArrayMembers = correctionModelArrayToCheck.length;
		for (let x = 0; x < numberOfArrayMembers; x++) {
			console.log(`at ${x} of ${numberOfArrayMembers}, arrayPositions is`, arrayPositions);
            if (correctionModelArrayToCheck[x].propertyDataSource == correctionDataArrayChangedEvent.correctionModel.propertyDataSource) {
                switch (correctionDataArrayChangedEvent.operation) {
					case DataCorrectionArrayEventOperation.AddNewItem:
						{
							//Copy the blank instance of the arrayItem

							var newCorrectionDataModel: CorrectionModel = deepClone(correctionDataArrayChangedEvent.correctionModel.arrayChildCorrectionModelFormat);
							//Re-index all of it and it's children's propertyDataSources so it correctly slots in at end of array
							//THe addition button is always one level up, at the array source level, so we need to pull the relevant child form group
							let actualFormGroupToUpdate = <FormGroup>formGroupToUpdate.controls[correctionDataArrayChangedEvent.correctionModel.propertyDataSource];

							arrayPositions.push(correctionModelArrayToCheck[x].childCorrectionModels.length);
							this.reIndexCorrectionModelAndFormGroup(arrayPositions[arrayPositions.length -1], newCorrectionDataModel,
								actualFormGroupToUpdate as FormGroup, correctionDataArrayChangedEvent.operation, arrayPositions);

							let formArray = Object.values(actualFormGroupToUpdate.controls);
							let last = <FormGroup>formArray[formArray.length - 1];

							if (last != null) {
								for (const controlName in last.controls) {
									if (controlName.endsWith("itemIsAdded")) {
										last.controls[controlName].setValue(true);
										let addProp = newCorrectionDataModel.childCorrectionModels.find(c => c.propertyDisplayName.startsWith("Item Is Added"));
										if (addProp != null) {
											addProp.propertyValue = true;
										}
									}
								}
							}

							correctionModelArrayToCheck[x].childCorrectionModels.push(newCorrectionDataModel);
							break;
						}

					case DataCorrectionArrayEventOperation.RemoveCurrentItem:
						{
							let addCtrl: AbstractControl = null;
							let removeCtrl: AbstractControl = null;
							let formArray: FormGroup;
							for (const controlName in formGroupToUpdate.controls) {
								if (controlName == correctionDataArrayChangedEvent.correctionModel.propertyDataSource) {
									formArray = formGroupToUpdate.controls[controlName] as FormGroup;
								}
							}
							if (formArray != null) {
								for (const controlName in formArray.controls) {
									if (controlName.endsWith('itemIsAdded')) {
										addCtrl = formArray.controls[controlName];
									} else if (controlName.endsWith('itemIsDeleted')) {
										removeCtrl = formArray.controls[controlName];
									}
								}
							}

							if (addCtrl == null && removeCtrl == null) { //old method, for arrays that are simple properties

								for (const controlName in formGroupToUpdate.controls) {
									if (controlName == correctionModelArrayToCheck[x].propertyDataSource) {
										formGroupToUpdate.controls[controlName].setValue(''); //in this case, we're dealing with simple controls, which are lists of strings, so setting the control's value to '' might suffice
									}
								}
							}					
							else if (addCtrl != null && addCtrl.value === true) {
								correctionModelArrayToCheck.splice(x, 1);
								formGroupToUpdate.removeControl(correctionDataArrayChangedEvent.correctionModel.propertyDataSource);
								//Now we need to rename everything in the array because indexing has changed
								for (let x = 0; x < correctionModelArrayToCheck.length; x++) {
									this.reIndexCorrectionModelAndFormGroup(x, correctionModelArrayToCheck[x], formGroupToUpdate, correctionDataArrayChangedEvent.operation, []); //something will likely get screwed up here when reapplying numbering when removing an added object from the array, if the array is nested in another array
								}
							} else if (removeCtrl != null) {
								removeCtrl.setValue(true);
							}

							break;
						}
				} 
                return;
            }
            if (correctionModelArrayToCheck[x].childCorrectionModels && correctionModelArrayToCheck[x].childCorrectionModels.length > 0) {
				let childFormGroup = formGroupToUpdate.controls[correctionModelArrayToCheck[x].propertyDataSource] as FormGroup;
				arrayPositions.push(x);
				this.processDataCorrectionArrayChangeEvent(correctionDataArrayChangedEvent, correctionModelArrayToCheck[x].childCorrectionModels, childFormGroup, arrayPositions);
				arrayPositions.pop();
			}
			arrayPositions = [];
        }
    }

    reIndexCorrectionModelAndFormGroup(newIndex: number, correctionModelToUpdate: CorrectionModel, formGroup: FormGroup, arrayOperationType: DataCorrectionArrayEventOperation, arrayPositions: number[]) {
		//arrayPositions will be an array of the childCorrectionModels from the top down of what the updated position indexes should be
		//we should ignore whatever the first entry is, because that will be the property position of the outermost object, which can't be an array in this context
		
		let existingDataSource = correctionModelToUpdate.propertyDataSource;
		let openBraceIndex = existingDataSource.indexOf("[");
		let closeBraceIndex = existingDataSource.indexOf("]");
		let arrayIndexToReplace = existingDataSource.substring(openBraceIndex + 1, closeBraceIndex); 
		let numberVersionOfPreviousIndex = Number(arrayIndexToReplace);
		let chunks = existingDataSource.split(']');
		let updatedDataSource = this.rewriteArrayCharacters(chunks.filter(c => c.trim().length > 0), arrayPositions);
		let nameIndexToReplace = (numberVersionOfPreviousIndex + 1).toString();
		let updatedPropertyName = correctionModelToUpdate.propertyDisplayName.replace(nameIndexToReplace, (newIndex + 1).toString()); 
        correctionModelToUpdate.propertyDisplayName = updatedPropertyName;
        this.updateCorrectionModelDataSourcePrefix(existingDataSource, updatedDataSource, correctionModelToUpdate);

        //Now update the FormGroup
        //Remove an existing control if it exists and this is a removal operation
        if (arrayOperationType == DataCorrectionArrayEventOperation.RemoveCurrentItem && formGroup.controls[existingDataSource])
            formGroup.removeControl(existingDataSource);

        //rebuild new FormControl
        let formGroupWithRebuiltControl = this.createFormGroup([correctionModelToUpdate]);
        //fetch the updated FormControl
        let rebuiltControl = formGroupWithRebuiltControl.controls[correctionModelToUpdate.propertyDataSource];
        formGroup.addControl(updatedDataSource, rebuiltControl);

	}

	getIndexValueToReplace(propertyString: string, startingPosition: number, endingPosition: number): string {
		return propertyString.substring(startingPosition, endingPosition);
	}


	rewriteArrayCharacters(stringChunks: string[], indexArray: number[]) : string {
		let assembledCharacters = "";
		for (let c = 0; c < stringChunks.length; c++) {
			let chunk = stringChunks[c];
			let openBracePositionInChunk = chunk.indexOf('[');
			let previousVersionNumber = this.getIndexValueToReplace(chunk, openBracePositionInChunk + 1, chunk.length);  //open brace will always precede the number to be replaced in the chunk, and the chunk will always end with the number that needs to be replaced
			let newVersionNumber = (stringChunks.length > 1) ? indexArray[c + 1] : indexArray[0]; //because the indexArray unavoidably includes the position of the top-most property, it should always be one size larger than the number of chunks, but need to grab the 1st if its only 1-deep
			let newChunk = chunk.replace(previousVersionNumber, newVersionNumber.toString());
			assembledCharacters = `${assembledCharacters}${newChunk}]`;
		}
		return assembledCharacters;
	}

    updateCorrectionModelDataSourcePrefix(oldPrefix: string, newPrefix: string, correctionModelToUpdate: CorrectionModel): CorrectionModel {
        let priorPrefix = correctionModelToUpdate.propertyDataSource;
        let updatedDataSource = correctionModelToUpdate.propertyDataSource.replace(oldPrefix, newPrefix);
        correctionModelToUpdate.propertyDataSource = updatedDataSource
        correctionModelToUpdate.propertyId = updatedDataSource;
        if (correctionModelToUpdate.childCorrectionModels) {
			for (let x = 0; x < correctionModelToUpdate.childCorrectionModels.length; x++) {
                this.updateCorrectionModelDataSourcePrefix(priorPrefix, updatedDataSource, correctionModelToUpdate.childCorrectionModels[x])
            }
        }
        return correctionModelToUpdate;
    }

    toggleOnlyAlteredFields() {
        this.showOnlyAlteredFields = !this.showOnlyAlteredFields;
        if (!this.showOnlyAlteredFields)
            this.viewAllButtonText = "Hide All Except Edited";
        else
            this.viewAllButtonText = "View All";
    }
}
